import { render, staticRenderFns } from "./AggregatedResultsTableBody.vue?vue&type=template&id=861fc5b8&scoped=true&"
import script from "./AggregatedResultsTableBody.vue?vue&type=script&lang=ts&"
export * from "./AggregatedResultsTableBody.vue?vue&type=script&lang=ts&"
import style0 from "./AggregatedResultsTableBody.vue?vue&type=style&index=0&id=861fc5b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "861fc5b8",
  null
  
)

export default component.exports